<template>
  <div class="app-container">
    <CrudTable entity="OrderDraft" :columns="columns" :on-row-dbl-click="onTableRowDoubleClick" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'id', label: 'orderLine.ticketNumber' },
        { field: 'customerReference', label: 'orderLine.customerReference' },
        { field: 'createdAt', label: 'common.createdAt', type: 'dateTime', filter: { type: 'date' } },
        { field: 'modifiedAt', label: 'common.modifiedAt', type: 'dateTime', filter: { type: 'date' } },
        { field: 'consumerName', label: 'order.consumerName' },
        { field: 'consumerStreet', label: 'common.streetName' },
        { field: 'consumerHouseNumber', label: 'common.houseNumber' },
        { field: 'consumerPostalCode', label: 'common.postalCode' },
        { field: 'consumerCity', label: 'common.city' },
        { field: 'orderLineCount', label: 'orderDraft.orderLineCount', filter: { type: 'none' }, sortable: false }
      ]
    };
  },
  methods: {
    onTableRowDoubleClick(row) {
      const id = row.id;
      this.$router.push({ name: 'EditOrderDraft', params: { id } });
    }
  }
};
</script>

<style scoped></style>
